module.exports = __webpack_public_path__ + "static/media/logoo.491b95bc.png";